import axios from "../axiosInstance";

export const attempRegister = async ({ email, firstName, lastName, password }) => {
  return await axios.post("/auth/register", { email, firstName, lastName, password }).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

export const attempLogin = async ({ email, password }) => {
  return await axios.post("/auth/login", { email, password }).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

export const attempLogout = async () => {
  return await axios.post("/auth/logout").then((res) => {
    if (res.status !== 200) {
      throw new Error(res.data.code);
    }
  });
};

export const attempAccountConfirmation = async ({ confirmationCode }) => {
  return await axios.get("/auth/confirm/" + confirmationCode).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

export const attempForgotPassword = async ({ email }) => {
  return await axios.post("/auth/forgotPassword", { email }).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

export const attempResetPassword = async ({ resetPasswordToken, password }) => {
  return await axios.post("/auth/resetPassword", { resetPasswordToken, password }).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

export const attempChangeName = async ({ firstName, lastName }) => {
  return await axios.patch("/auth/profile", { firstName, lastName }).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};

export const attempChangePassword = async ({ oldPassword, newPassword }) => {
  return await axios.patch("/auth/password", { oldPassword, newPassword }).then((res) => {
    if (res.status === 200) {
      return res.data.data;
    } else {
      throw new Error(res.data.code);
    }
  });
};
